import React from 'react';
import _, { get } from 'lodash';
import { getDisplayDate } from '../../../libs/date';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { roundOff, stageAddition, notNull } from './helpers';
import DataTable from '../../DataTable';

@observer
class RTable extends React.Component {
  state = {
    allChecked: false
  }

  @action handleChange = () => {
    let { dataByDate } = this.props;
    this.setState({ allChecked: !this.state.allChecked })
    Object.keys(dataByDate).map((item) => {
      if (!dataByDate[item].disabled) {
        if (!this.state.allChecked) {
          dataByDate[item].checked = true
        } else {
          dataByDate[item].checked = false
        }
      }
    })
  }

  @action handleRowChange = (item) => {
    this.setState({ allChecked: false })
    item.checked = !item.checked;
    this.props.optimizeOffset();
  }

  getPolynomialColumnAndData = (props) => {
    let { dataByDate, parameters, useLog, selectedPoint } = props;
    const columns = [
      { label: <input type="checkbox" name="" value="" checked={this.state.allChecked} onChange={this.handleChange} />, key: 'checkbox' },
      { label: 'Date', key: 'date', sortable: true },
      // { label: 'WL', key: 'wl', sortable: true },
      { label: useLog ? 'ln(WL - h0)' : 'WL - h0', key: 'stage', sortable: true },
      { label: useLog ? 'ln(Q)' : 'Q', key: 'q', sortable: true },
      { label: useLog ? 'ln(Gen Q)' : 'Gen Q', key: 'gen_q', sortable: true },
      { label: 'Difference (%)', key: 'error', sortable: true },
    ];
    const data = Object.keys(dataByDate).map(date => {
      let stage = dataByDate[date].WL_M;
      let genQ = parameters.a + (stage * parameters.b) + (stage * stage * parameters.c);
      let displayStage = useLog ? roundOff(Math.log(stage), 2) : stage;
      let displayQ = useLog ? roundOff(Math.log(dataByDate[date].Q_M)) : dataByDate[date].Q_M
      let displayGenQ = useLog ? roundOff(Math.log(genQ)) : roundOff(genQ)
      let isSelected = !!selectedPoint && roundOff(selectedPoint.x, 2) === displayStage && roundOff(selectedPoint.y) === displayQ;
      let error = roundOff(100 * Math.abs(displayGenQ - displayQ) / displayQ, 0);

      return {
        checkbox: <input type="checkbox" checked={dataByDate[date].checked} onChange={() => this.handleRowChange(dataByDate[date])} />,
        date: getDisplayDate(date),
        wl: roundOff(dataByDate[date].WL_M, 4),
        stage: roundOff(displayStage, 4),
        q: roundOff(displayQ, 4),
        gen_q: notNull(displayGenQ) ? roundOff(displayGenQ, 4) : '-',
        error: notNull(error) ? roundOff(error, 4) : '-',
        highlight: isSelected
      }
    });
    return { columns, data };
  }

  getPowerColumnAndData = (props) => {
    let { dataByDate, parameters, parameterOffsets, useLog, selectedPoint } = props;
    const columns = [
      { label: <input type="checkbox" name="" value="" checked={this.state.allChecked} onChange={this.handleChange} />, key: 'checkbox' },
      { label: 'Date', key: 'date', sortable: true },
      { label: 'WL', key: 'wl', sortable: true },
      { label: useLog ? 'ln(WL - h0)' : 'WL - h0', key: 'stage', sortable: true },
      { label: useLog ? 'ln(Q)' : 'Q', key: 'q', sortable: true },
      { label: useLog ? 'ln(Gen Q)' : 'Gen Q', key: 'gen_q', sortable: true },
      { label: 'Difference (%)', key: 'error', sortable: true },
    ];
    const data = Object.keys(dataByDate).map(date => {
      let stage = stageAddition(dataByDate[date].WL_M, parameterOffsets.offset * -1);
      let genQ = parameters.a * (stage ** parameters.b);
      let displayStage = useLog ? roundOff(Math.log(stage), 2) : stage;
      let displayQ = useLog ? roundOff(Math.log(dataByDate[date].Q_M)) : dataByDate[date].Q_M
      let displayGenQ = useLog ? roundOff(Math.log(genQ)) : roundOff(genQ)
      let isSelected = !!selectedPoint && roundOff(selectedPoint.x, 2) === displayStage && roundOff(selectedPoint.y) === displayQ;
      let error = roundOff(100 * Math.abs(displayGenQ - displayQ) / displayQ, 0);

      return {
        checkbox: dataByDate[date].disabled ? <i /> : <input type="checkbox" checked={dataByDate[date].checked} onChange={() => this.handleRowChange(dataByDate[date])} />,
        date: getDisplayDate(date),
        wl: roundOff(dataByDate[date].WL_M, 4),
        stage: roundOff(displayStage, 4),
        q: roundOff(displayQ, 4),
        gen_q: notNull(displayGenQ) ? roundOff(displayGenQ, 4) : '-',
        error: notNull(error) ? roundOff(error, 4) : '-',
        highlight: isSelected,
      }
    });
    return { columns, data };
  }

  getColumnAndData = (props) => {
    switch (+props.parameters.type) {
      case 1: return this.getPowerColumnAndData(props);
      case 2: return this.getPolynomialColumnAndData(props);
      default: return { columns: [], data: [] };
    }
  }

  render() {
    const { columns, data } = this.getColumnAndData(this.props);

    return (
      <div style={{ height: "450px", overflow: "auto" }}>
        <DataTable data={data} columns={columns} centered paginate={false} stickyHeader />
      </div>
    )
  }
}

export default RTable;


// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RTable2.js